import { createAction, handleActions } from "redux-actions";
import axios from "axios";
import { REQUEST_BLOB_URL, RECEIVE_BLOB_URL, RESET_BLOB, UPDATE_BLOB_PROGRESS } from "../types";

// import scraperConfig from "../scraperConfig";

// const defaultState = Object.fromEntries(
//   Object.entries(scraperConfig).map(([key]) => [key,    {
//     isLoading: false,
//     progress: 0,
//     url: false
//   }])
// );

const defaultState = {};

const requestBlobUrl = createAction(REQUEST_BLOB_URL, (id) => ({
    id
}));

const recieveBlobUrl = createAction(RECEIVE_BLOB_URL, (blobUrl, id) => ({
    blobUrl,
    id
}));

const updateProgress = createAction(UPDATE_BLOB_PROGRESS, (progress, id) => ({
    progress,
    id
}));

export const resetBlob = createAction(RESET_BLOB, (id) => ({
    id
}));

export function fetchBlobUrl(streamUrl) {
    return (dispatch) => {
        dispatch(requestBlobUrl());

        return axios
            .get(streamUrl, {
                headers: { Accept: "audio/mp3" },
                responseType: "blob",
                onDownloadProgress (progressEvent) {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    dispatch(updateProgress(percentCompleted));
                }
            })
            .then((blob) => {
                const objectURL = (window.URL || window.webkitURL).createObjectURL(blob.data);

                dispatch(recieveBlobUrl(objectURL));
            });
    };
}

const artistName = handleActions(
    {
        [requestBlobUrl]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: { ...state[action.payload.id], isLoading: true }
            };
        },
        [recieveBlobUrl]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    isLoading: false,
                    url: `${action.payload.blobUrl}`,
                    progress: 0
                }
            };
        },
        [updateProgress]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    progress: action.payload.progress
                }
            };
        },
        [resetBlob]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: {
                    isLoading: false,
                    progress: 0,
                    url: false
                }
            };
        }
    },
    defaultState
);

export default artistName;
